<template>
  <div class="row">
    <div class="col-12">
      <select :ref="'sectionSelect'+unique_id" :id="'sectionSelect'+unique_id" v-model="selected_task.section_id"  class="form-control form-control-sm mb-2" data-toggle="select">
        <option  :selected="selected_task.section_id === section._id" v-for="section in sections.filter(section_object => section_object.project_id === selected_task.project_id)"
                 :value="section._id" >
          {{section.name}}
        </option>
      </select>
    </div>
  </div>

</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        name: "sectionSelect",
        props: {

        },
        data: function () {
            return {
                unique_id: '1'
            }

        },
        computed: {
            ...mapGetters([
                'account',
                'selected_account_id',
                'selected_project_id',
                'selected_task',
                'sections',
            ]),
        },
        watch: {
            sections: function (new_val, old_val) {
                this.enableSelect()

            },
            selected_task: function (new_val, old_val) {
                this.enableSelect()
            },
            selected_project_id: function (new_val, old_val) {
                this.enableSelect()
            }
        },
        methods: {
            enableSelect() {
                let self = this;
                function init_select($this) {
                    var options = {
                        dropdownParent: $this.closest('.modal').length ? $this.closest('.modal') : $(document.body),
                        minimumResultsForSearch: $this.data('minimum-results-for-search'),
                        templateResult: formatAvatar
                    };
                    $this
                        .select2(options)
                        .on('change', function () {
                            self.selected_task.section_id = this.value;
                    });
                }

                function formatAvatar(avatar) {
                    if ( !avatar.id ) {
                        return avatar.text;
                    }
                    var $option = $(avatar.element);
                    var optionAvatar = $option.data('avatar-src');
                    var optionPosition = $option.data('position');
                    var output;
                    if (!optionPosition) {
                        optionPosition = '';
                    } else if (optionPosition.length > 20) {
                        optionPosition = optionPosition.slice(0, 17)+'...'
                    }
                    if ( optionAvatar ) {
                        output = $('<span class="avatar avatar-xs mr-3"><img class="avatar-img rounded-circle" src="' + optionAvatar + '" alt="..."></span><span>' + avatar.text + '</span><span class="text-muted float-right">'+optionPosition +'</span>');
                    } else {output = avatar.text}
                    return output;
                }
                setTimeout(() => init_select( $(document.getElementById('sectionSelect'+self.unique_id))), 100);
            }
        },
        created(){
            this.unique_id = Math.random().toString();
            this.enableSelect();
        },

    }
</script>

<style scoped>

  .project_pic {
    border-radius: 4px;
    /*background: linear-gradient(#e66465, #9198e5);*/
    background: linear-gradient(217deg, rgba(255,0,0,.8), rgba(255,0,0,0) 70.71%),
    linear-gradient(127deg, rgba(0,255,0,.8), rgba(0,255,0,0) 70.71%),
    linear-gradient(336deg, rgba(0,0,255,.8), rgba(0,0,255,0) 70.71%);
    padding: 0px;
    opacity: 80%;
    width: 20px;
    height: 22px;

  }

</style>
